import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // importa Bootstrap

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { efetuarLogin } from '../servicos/loginServico';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    console.log('!!! Entrou no useEffect do Login.js');

    // // ✅ Remove o cookie ao entrar na página
    // Cookies.remove('dadosCookies');
    // console.log('dadosCookies removido');

    const dadosCookies = Cookies.get('dadosCookies');
    console.log('dadosCookies: ', dadosCookies);

    if (dadosCookies) {
      try {
        const parsed = JSON.parse(dadosCookies);
        const perfil = parsed?.perfis[0].toLowerCase();
        const statusUsuario = parsed.status_usuario;

        console.log('status do usuário: ', statusUsuario);
        console.log('perfis do usuário: ', perfil);

        if (statusUsuario === 'usuário logado') {
          switch (perfil) {
            case 'adm técnico':
              navigate('/pagina-adm-tecnico');
              break;
            case 'melgs cliente':
              navigate('/pagina-cliente');
              break;
            case 'melgs representante comercial':
              navigate('/pagina-representante-comercial');
              break;
            case 'melgs ponto mototaxi':
              navigate('/pagina-ponto-mototaxi');
              break;
            case 'melgs piloto mototaxi':
              navigate('/pagina-piloto-mototaxi');
              break;
            default:
              console.warn('Perfil desconhecido:', perfil);
          }
        }
      } catch (error) {
        console.error('Erro ao interpretar os dados dos cookies:', error);
      }
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();

    console.log('Entrou em handleLogin...');

    try {
      const dados = { email, password };
      const resposta = await efetuarLogin(dados);

      console.log('Resposta recebida: ', resposta);

      if (resposta && resposta.dadosUsuario && resposta.status_usuario === 'usuário logado') {
        console.log('... vai setar os cookies...', resposta);

        Cookies.set('dadosCookies', JSON.stringify(resposta), { expires: 7 });

        const perfil = resposta.perfis[0].toLowerCase();
        console.log('Perfil: ', perfil);

        switch (perfil) {
          case 'adm técnico':
            navigate('/pagina-adm-tecnico');
            break;
          case 'melgs representante comercial':
            navigate('/pagina-representante-comercial');
            break;
          case 'cliente':
            navigate('/pagina-cliente');
            break;
          case 'melgs ponto mototaxi':
            navigate('/pagina-ponto-mototaxi');
            break;
          case 'melgs piloto mototaxi':
            navigate('/pagina-piloto-mototaxi');
            break;
          default:
            alert('Perfil desconhecido');
        }
      } else {
        alert('Usuário ou senha inválidos');
      }
    } catch (error) {
      alert('Erro ao efetuar login. Tente novamente.');
      console.error('Erro no login:', error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light p-3">
      <div className="card shadow p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <h3 className="text-center mb-4">Login</h3>

        <form onSubmit={handleLogin}>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="emailInput"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label htmlFor="emailInput">E-mail</label>
          </div>

          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              id="senhaInput"
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <label htmlFor="senhaInput">Senha</label>
          </div>

          <button type="submit" className="btn btn-primary w-100 mb-3">
            Entrar
          </button>

          {/* <button
            type="button"
            className="btn btn-outline-primary w-100 mb-3"
            onClick={() => console.log('Ir para tela de cadastro')}
          >
            Criar conta
          </button> */}

          <div className="d-flex justify-content-center mt-2">

            {/* <GoogleLogin
              onSuccess={(credentialResponse) => {
                const decoded = jwtDecode(credentialResponse.credential);
                console.log('Usuário Google:', decoded);
              }}
              onError={() => {
                console.log('Erro no login com Google');
              }}
              width="100%"
            /> */}

          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
